import { Text, Box } from "@chakra-ui/react";

export default function NotFound() {
  return (
    <div id='not-found'>
      <Box textAlign='center' mt={10}>
        <Text fontSize='3xl' as='u' color='white'>
          Error
        </Text>
      </Box>
      <Box textAlign='center'>
        <Text fontSize='3xl' color='white'>
          The requested route has not been found.
        </Text>
      </Box>
    </div>
  );
}
